/**
 * financing-popup.js — open/close for the PDP financing pop-up.
 *
 * Document-level delegation on purpose: Dawn re-renders the price wrapper
 * (#price-{sectionId}) innerHTML on every variant change, which replaces the
 * trigger and modal nodes and would orphan directly-bound listeners (inline
 * <script> tags inside re-rendered HTML also never re-execute). Delegated
 * handlers survive any re-mount; the fresh modal re-renders server-side with
 * the new variant's amounts, so no state needs carrying over.
 */
(function () {
  if (window.__mxFinancingPopupBound) return;
  window.__mxFinancingPopupBound = true;

  function getPopup() {
    return document.getElementById('financingPopup');
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('#openFinancingPopup')) {
      event.preventDefault();
      var popup = getPopup();
      if (popup) popup.style.display = 'block';
      return;
    }

    if (target.closest('#closeFinancingPopup')) {
      var popup = getPopup();
      if (popup) popup.style.display = 'none';
      return;
    }

    var popup = getPopup();
    if (popup && event.target === popup) {
      popup.style.display = 'none';
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var popup = getPopup();
    if (popup && popup.style.display === 'block') {
      popup.style.display = 'none';
    }
  });

  // The modal lives OUTSIDE the section's re-render targets, so Dawn never
  // refreshes it on variant change. The variant fetch's section render DOES
  // include a fresh modal (it's part of the section file's output) — swap
  // its contents in so Klarna/ShopPay/Kwipped amounts track the variant.
  // Open/closed state is untouched (display lives on the overlay we keep).
  function syncFromSectionHtml(html) {
    if (!html || !html.getElementById) return;
    var fresh = html.getElementById('financingPopup');
    var current = getPopup();
    if (!fresh || !current) return;
    current.innerHTML = fresh.innerHTML;
    try {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    } catch (e) { /* swallow */ }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data) syncFromSectionHtml(event.data.html);
    });
  }
})();
